<template>
  <div>
    <el-dialog width="800px"
               :title="title"
               :visible.sync="viewDetail"
               :close-on-click-modal='false'
               @close="closeModel">
      <div class="table-box">
        <el-form :model="ruleForm"
                 :rules="rules"
                 ref="ruleForm"
                 style="margin-top:20px; width: 600px;">
          <el-form-item label="分类名称:"
                        prop='sortName'
                        :label-width="formLabelWidth">
            <el-input type="text"
                      v-model="ruleForm.sortName"
                      maxlength="5"
                      show-word-limit
                      placeholder="输入分类名称"></el-input>
          </el-form-item>
          <el-form-item label="分类图片:"
                        prop='sortNameIMG'
                        :label-width="formLabelWidth">
            <el-upload style="display: inline-block"
                       action="#"
                       :file-list="ruleForm.sortNameIMG"
                       :multiple="true"
                       list-type="picture-card"
                       :on-change="handleChange"
                       :auto-upload="false"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove"
                       :class="ruleForm.sortNameIMG.length == 1 ? 'mf' : ''"
                       :limit="1">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-link type="danger"
                     :underline="false">建议上传：图片尺寸为 140x140 (背景为空像素效果最佳)</el-link>
          </el-form-item>
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   style="margin-top:20px; width: 600px;">
            <el-form-item label="关联商品:"
                          prop='tableData'
                          :label-width="formLabelWidth">
              <el-button type="primary"
                         size="medium"
                         @click="addSortClick">添 加</el-button>
              <div v-if="ruleForm.tableData.length>0" style="margin-top:20px"><!-- v-else -->
                <el-table :data="ruleForm.tableData"
                          border
                          ref="multipleTable"
                          :row-class-name="handleCurrentIndex"
                          @row-click='handleCurrentChange'
                          highlight-current-row
                          style="width: 100%">
                  <el-table-column type="index"
                                   width="55"
                                   label="序号">
                  </el-table-column>
                  <el-table-column prop="imgs_mains"
                                   label="商品图片">
                    <template slot-scope="scope">
                      <img :src="scope.row.imgs_mains"
                           style="width:80px">
                    </template>
                  </el-table-column>
                  <el-table-column prop="goods_id"
                                   label="商品ID">
                  </el-table-column>
                  <el-table-column prop="tits"
                                   :show-overflow-tooltip="true"
                                   label="商品名称">
                  </el-table-column>
                  <el-table-column prop="address"
                                   label="操作">
                    <template slot-scope="scope">
                      <el-link type="success"
                               v-if="title=='编辑'"
                               style="padding-right：10px"
                               :underline="false"
                               @click="clickChange(scope.row.goods_id)"> 替换 </el-link>&nbsp;
                      <el-link type="danger"
                               :underline="false"
                               @click="deteleFn(scope.row)">&nbsp;删除</el-link>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="btn"
                     style="margin-top:20px">
                  <el-button @click="upmove"><i class="el-icon-arrow-up"></i></el-button>
                  <el-button @click="downmove"><i class="el-icon-arrow-down"></i></el-button>
                </div>
              </div>

            </el-form-item>
          </el-form>
          <!--   -->
          <div class="btn">
            <el-button @click="closeModel">取消</el-button>
            <el-button type="primary"
                       :loading='loading'
                       @click="submitHandle">保存</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <div v-if="viewDetail1">
      <fixAddGoods ref='addgoods'
                   @closeModel='initModel'
                   :titles='titles'
                   :goods_id='goods_id'
                   :tableindex='tableindex'
                   :method='getdecorateSortList'
                   :categoodsid='cate_goods_id'
                   @submitTable='submitTable'></fixAddGoods>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import fixAddGoods from './fixAddGoods.vue'
import { mapActions, mapGetters } from "vuex";
export default {
  props: ['method', 'title', 'cate_goods_id',],
  data () {
    return {
      viewDetail: true,
      viewDetail1: false,
      formLabelWidth: '120px',
      titles: '',
      ruleForm: {
        sortName: '',
        sortNameIMG: [],
        sortNameIMG_URL: '',
        tableData: []
      },
      rules: {
        sortName: [
          { required: true, trigger: 'blur', message: '不能为空' },
        ],
        sortNameIMG: [
          { required: true, trigger: 'blur', message: '不能为空' },
        ],
        /*   tableData: [
            { required: true, trigger: 'change', message: '不能为空' },
          ], */
      },
      dialogImageUrl: "",
      dialogVisible: false,
      goodsID: '',
      selectTable: [],
      allselectList: [],
      total: 0,
      page: 1,
      size: 10,
      tableData: [],
      loading: false,
      indexRow: '',
      flag: false,
      goods_id: '',
      tableindex:0,
    };
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  watch: {
    'ruleForm.tableData': function(newName,oldName) {
      this.$nextTick(()=>{
            this.$refs.multipleTable.setCurrentRow(
            this.ruleForm.tableData[0],true
          );})
          this.indexRow = this.ruleForm.tableData[0]
    }
  },

  mounted () {
    if (this.title == '编辑') {
      this.getdecorateSortList()
    }
  },
  methods: {
    ...mapActions({
      decorateSortList: "detect/decorateSortList", //详情
      uploadFile: "commodity/uploadFile",
      decorateGoodsList: "detect/decorateGoodsList", //列表
      decorateSortCateCreate: "detect/decorateSortCateCreate", //添加
      decorateSortEditSave: "detect/decorateSortEditSave", //编辑保存
      decorateSortEditDel: "detect/decorateSortEditDel", //编辑保存
  
    }),
    closeModel () {
      this.$emit("closeModel");
    },
    submitHandle () {
      if (this.ruleForm.tableData.length==0) {
        this.$message.error('请关联商品')
      }else{
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新增') {
            this.setdecorateSortCateCreate()
          } else {
            this.setdecorateSortEditSave()
          }
        } else {
          return false;
        }
      });       
      }
    },
    clickChange (item) {
      this.goods_id = item
      this.titles = '替换关联商品'
      this.viewDetail1 = true
    },
    deteleFn (item) {
      if (this.title == '新增') {
        this.ruleForm.tableData.splice(this.ruleForm.tableData.indexOf(item), 1)
      } else {
        this.setdecorateSortEditDel(item.goods_id, item)
      }
    },
  
    setdecorateSortEditDel (goods_id, item) {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        goods_id: goods_id,
        id: this.cate_goods_id
      }
      this.decorateSortEditDel(params).then((res) => {
        if (res.data.code == 1) {
          this.ruleForm.tableData.splice(this.ruleForm.tableData.indexOf(item), 1)
        } else {
         // this.$message.error('删除失败')
            this.ruleForm.tableData.splice(this.ruleForm.tableData.indexOf(item), 1)
        }
      }

        /*  if(){
       
         }
         "shop_id":1,店铺id
          "goods_id":105,商品id
          "id":19类目iid */

      )
    },
    submitTable (data) {
      this.ruleForm.tableData = this.ruleForm.tableData.concat(data)
    },
    initModel () {
      this.viewDetail1 = false
    },
    handleCurrentChange (row) {
      console.log(row,'row----')
      this.flag = true
      this.indexRow = row
    },
    handleCurrentIndex ({ row, rowIndex }) {
      row.goods_sort = rowIndex
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleChange (file, fileList) {
      var formdata = new FormData();
      formdata.append("formdata", file.raw);
      this.ruleForm.sortNameIMG = fileList;
      this.uploadFile(formdata).then((res) => {
        if (res.code == 1) {
          this.$message.success("上传成功！");
          this.ruleForm.sortNameIMG_URL = res.data.formdata_details[0].urls;
        } else {
          this.ruleForm.sortNameIMG = []
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
    handleRemove (file, fileList) {
      this.ruleForm.sortNameIMG = []
      this.ruleForm.sortNameIMG_URL = ''
    },
    addSortClick (id) {
      this.viewDetail1 = true
      if (this.title == '新增') {
        this.tableindex = this.ruleForm.tableData.length
        console.log(this.ruleForm.tableData.length,'tableDatatableData')
        this.titles = '添加关联商品'
      } else {
        this.titles = '编辑关联商品'
      }

    },
    upmove () {
      if (this.flag == false) this.$message.error('请点击需要排序的商品')
      let index = ''
      index = this.indexRow.goods_sort
      if (this.indexRow.goods_sort == 0) {
        this.$message.error('商品排序已在第一位');
      } else {
        const len = this.ruleForm.tableData[index - 1]
        this.$set(this.ruleForm.tableData, index - 1, this.ruleForm.tableData[index])
        this.$set(this.ruleForm.tableData, index, len)
      }
    },
    downmove () {
      let index = this.indexRow.goods_sort
      if (this.indexRow.goods_sort == this.ruleForm.tableData.length - 1) {
        this.$message.error('商品排序已在最后一位');
      } else {
        const len = this.ruleForm.tableData[index + 1]
        this.$set(this.ruleForm.tableData, index + 1, this.ruleForm.tableData[index])
        this.$set(this.ruleForm.tableData, index, len)
      }
    },

    setdecorateSortCateCreate () {
      this.loading = true
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        name: this.ruleForm.sortName,
        category_image: this.ruleForm.sortNameIMG_URL,
        goods_list: this.ruleForm.tableData
      }
      this.decorateSortCateCreate(params).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.closeModel()
          this.method()
        } else {
          this.loading = false
          this.$message.error(res.data.msg);
        }
      })
    },
    setdecorateSortEditSave () {
      this.loading = true
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        name: this.ruleForm.sortName,
        category_image: this.ruleForm.sortNameIMG_URL,
        goods_list: this.ruleForm.tableData,
        id: this.cate_goods_id
      }
      this.decorateSortEditSave(params).then(res => {
        this.loading = false
        if (res.data.code == 1) {
          this.$message.success(res.data.msg);
          this.closeModel()
          this.method()
        } else {
          this.loading = false
          this.$message.error(res.data.msg);
        }

      })
    },
    //编辑详情
    getdecorateSortList () {
      let params = {
        token: this.getToken,
        shop_id: this.$route.query.id,
        id: this.cate_goods_id
      }
      this.decorateSortList(params).then(res => {
        if (res.data.code == 1) {
          this.ruleForm.sortName = res.data.data.cate.categroy_name
          this.ruleForm.sortNameIMG_URL = res.data.data.cate.category_image
          this.ruleForm.sortNameIMG = [{ url: res.data.data.cate.category_image }]
          this.ruleForm.tableData = res.data.data.goods

        } else {
          this.$message.error(res.data.msg);
        }

      })
    },

  },
  components: {
    fixAddGoods

  },
};
</script>

<style scoped lang="scss">
.table-box {
  width: 100%;

  /* min-height: 600px; */
}

::v-deep.el-table {
  .DisabledSelection .cell .el-checkbox__inner {
    display: none;
    position: relative;
  }
}

::v-deep .el-table {
  .DisabledSelection {
    .cell:before {
      content: "操作";
      position: absolute;
      right: 35px;
    }
  }
}
::v-deep .el-input--medium .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.pageSize {
  text-align: right;
  margin-top: 20px;
  margin-bottom: 30px;
}
.mf {
  ::v-deep .el-upload--picture-card {
    display: none !important;
  }
}
.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
